import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import {LogOut} from "../../domains/common/components/Head";
import {
  Grid, IconButton,
  Tooltip, useTheme, Drawer, Container
} from "@mui/material";
import {RegistrationTypes, RolesEnums} from "../../enums";
import Box from "@mui/material/Box";
import {Item} from "../../domains/common/components/Item";
import FormSelect from "../../domains/common/components/FormSelect";
import {exceptionsTitle, registrationTypesSelect} from "../../dictionaries";
import {TextareaCtrl} from "../../domains/common/components/FormInput";
import {useNotify} from "../../domains/common/components/AlertNotify";
import {DKPAddParamsContainer, DKPDealContainer} from "./containers/DealDKPContainer";
import {
  DealAddStatementContainer,
  DKPAddStatementParamsContainer
} from "./containers/DealAddStatementContainer";
import {RepaymentMortgageParamsContainer} from "./containers/DealRepaymentMortgageContainer";
import {
  AssignmentAgreementParamsContainer,
  DealAssignmentAgreement
} from "./containers/DealAssignmentAgreement";
import {
  DealMakingChangesContainer,
  MakingChangesParamsContainer
} from "./containers/DealMakingChanges";
import {DealEnteringInfoToEGRN, EnteringInfoParamsContainer} from "./containers/DealEnteringInfoToEGRN";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {DealMortgageRegistrationContainer} from "./containers/DealMortgageRegistrationContainer";
import {
  DealShareRegistrationContainer,
  ShareAddParamsContainer
} from "./containers/DealShareRegistrationContainer";
import {DealRegRentAgreementContainer} from "./containers/DealRegRentAgreementContainer";
import {DealGKUwRightContainer} from "./containers/DealGKUwRight";
import {DealGKUwoRightContainer} from "./containers/DealGKUwoRight";
import {DealRegMortgageAgreement} from "./containers/DealRegMortgageAgreement";
import {
  DealChangeSpecificationContainer,
  MakingChangesSpecificationContainer
} from "./containers/DealChangeSpecification";
import {
  AddRegShareCommonPropContainer,
  DealRegShareCommonPropContainer
} from "./containers/DealRegShareCommonProp";
import {DealPrevRight1998} from "./containers/DealPrevRight1998";
import {CriticalErrorsComponent} from "../../domains/common/components/CriticalErrors";
import {loadUserOptions, userOptions} from "../../user";
import {Link1, Title5} from "../../domains/common/components/Typography";
import {useCustomeTheme} from "../../domains/common/components/ThemeContext";
import {DealParamsMortgageAndExpress} from "./components/DealParams";
import {DealActionsEnums, handleDealAction} from "../../actions";
import {BackButtonToDealList} from "../../domains/common/components/Button";
import {RegRightDealContainer} from "./containers/DealRegRightContainer";
import {createNewDeal, dealData, dealLoad, saveDealParams} from "./deal";
import {waitInputComplete} from "../../fn";
import {useDeal} from "./useDeal";
import {DealHeader} from "./components/Header";
import {DealContent} from "./components/Content";
import {useDealPageDrawer} from './useDealDrawer';

const queryParameters = new URLSearchParams(window.location.search)
const id = queryParameters.get("id")

export const DealPageContext = createContext();

const DealPageProvider = ({children}) => {
  const [loading, setLoading] = useState(true);
  const {dataHasLoaded, dealContainer, addParamsContainer, changeDealType, title, saveTitle, makeTitle} = useDeal();
  const {openNotify} = useNotify();
  const { DrawerComponent, toggleDrawer, closeDealDrawer } = useDealPageDrawer();

  const dealPageValue = useMemo(() => ({
    dataHasLoaded, dealContainer, addParamsContainer, changeDealType, title, saveTitle, makeTitle, toggleDrawer, closeDealDrawer
  }), [dataHasLoaded, dealContainer, changeDealType, title]);

  return (
    <DealPageContext.Provider value={dealPageValue}>
      <DrawerComponent />
      {children}
    </DealPageContext.Provider>
  );
};

export default function DealPage() {
  const theme = useTheme();

  return (
    <DealPageProvider>
      <Box sx={{
        width: "100%",
        minHeight: '100%',
        paddingBottom: '50px',
        boxSizing: 'border-box',
        backgroundColor: theme.palette.background.secondary
      }}>
        <Grid container spacing={0} wrap="nowrap" sx={{overflow: "auto", pt: '4px', pb: '20px'}}>
          <Grid item xs={2.5} sx={{minWidth: '80px'}}>
            <BackButtonToDealList/>
          </Grid>
          <Grid item xs={7} sx={{minWidth: '1050px'}}>
            <DealHeader/>
            <DealContent/>
          </Grid>
          <Grid item xs={2.5} sx={{minWidth: '80px'}}>
            <Box sx={{lineHeight: '50px'}} display="flex" justifyContent="flex-end"><LogOut/></Box>
          </Grid>
        </Grid>
      </Box>
    </DealPageProvider>
  )
}
